
import axios from '../apis/axios';
import { useLocalStorage } from "./useLocalStorage";

const useRefreshToken = () => {
    const [user, setUser] = useLocalStorage("user", null);
  
    const refresh = async () => {
        console.log("refersh");
        const response = await axios.get('/api/refresh', { headers:{"Authorization": `Bearer ${user?.api_token}`},
            withCredentials: true
        });
        console.log('useRefreshToken New', response);
        setUser(prev => {
            console.log("useRefreshToken prev", JSON.stringify(prev));
            console.log(response.data.accessToken);
            return { ...prev, api_token: response.data.api_token }
        });
        return response.data.api_token;
    }
    return refresh;
};

export default useRefreshToken;
